import { useEffect, useState } from "react";

const LogoutScreen = () => {
  const [countdown, setCountdown] = useState(5);
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          handleRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleRedirect = () => {
    setIsRedirecting(true);
    // Limpar dados de sessão se necessário
    // localStorage.clear();
    // sessionStorage.clear();

    setTimeout(() => {
      window.location.href = "https://santacruzbr.com.br/";
    }, 500);
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <>
      {/* Bootstrap 5 CSS */}
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
        rel="stylesheet"
      />

      {/* Custom Styles */}
      <style jsx>{`
        .logout-screen {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          min-height: 100vh;
          animation: fadeIn 0.6s ease-out;
        }

        .logout-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border: none;
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.1);
          animation: slideUp 0.8s ease-out;
          position: relative;
          overflow: hidden;
        }

        .logout-card::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #667eea, #764ba2);
          animation: progressBar 5s linear;
        }

        .logout-icon {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #667eea, #764ba2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          animation: bounceIn 1s ease-out 0.3s both;
        }

        .logout-icon svg {
          width: 40px;
          height: 40px;
          fill: white;
        }

        .btn-gradient {
          background: linear-gradient(135deg, #667eea, #764ba2);
          border: none;
          transition: all 0.3s ease;
        }

        .btn-gradient:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
          background: linear-gradient(135deg, #5a6fd8, #6842a0);
        }

        .btn-outline-gradient {
          border: 2px solid #667eea;
          color: #667eea;
          background: transparent;
          transition: all 0.3s ease;
        }

        .btn-outline-gradient:hover {
          background: linear-gradient(135deg, #667eea, #764ba2);
          border-color: #667eea;
          color: white;
          transform: translateY(-2px);
        }

        .countdown-number {
          font-weight: bold;
          color: #667eea;
          font-size: 1.1em;
        }

        .spinner-container {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes bounceIn {
          0% {
            transform: scale(0);
          }
          50% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
          }
        }

        @keyframes progressBar {
          from {
            width: 0%;
          }
          to {
            width: 100%;
          }
        }

        @keyframes pulse {
          0%,
          100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }

        .animate-pulse {
          animation: pulse 1.5s infinite;
        }
      `}</style>

      <div className="logout-screen d-flex align-items-center justify-content-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card logout-card rounded-4">
                <div className="card-body p-4 p-md-5 text-center">
                  {/* Ícone de Logout */}
                  <div className="logout-icon">
                    <svg viewBox="0 0 24 24">
                      <path d="M17,7L15.59,8.41L18.17,11H8V13H18.17L15.59,15.59L17,17L22,12L17,7M4,5H12V3H4C2.89,3 2,3.89 2,5V19A2,2 0 0,0 4,21H12V19H4V5Z" />
                    </svg>
                  </div>

                  {/* Título */}
                  <h2 className="h3 fw-bold text-dark mb-3">
                    {isRedirecting ? "Redirecionando..." : "Logout Realizado"}
                  </h2>

                  {/* Mensagem */}
                  <p className="text-muted mb-4 lead">
                    {isRedirecting ? (
                      <span className="animate-pulse">
                        Aguarde, você está sendo redirecionado...
                      </span>
                    ) : (
                      <>
                        Você foi desconectado com sucesso.
                        <br />
                        <small>Obrigado por usar nossos serviços!</small>
                      </>
                    )}
                  </p>

                  {/* Botões de Ação */}
                  {!isRedirecting && (
                    <div className="d-grid gap-3 mb-4">
                      <button
                        className="btn btn-gradient text-white py-2 rounded-3"
                        onClick={handleRedirect}
                      >
                        <i className="bi bi-house-door me-2"></i>
                        Ir para Santa Cruz
                      </button>

                      <button
                        className="btn btn-outline-gradient py-2 rounded-3"
                        onClick={handleGoBack}
                      >
                        <i className="bi bi-arrow-left me-2"></i>
                        Voltar
                      </button>
                    </div>
                  )}

                  {/* Loading Spinner para Redirecionamento */}
                  {isRedirecting && (
                    <div className="spinner-container justify-content-center mb-4">
                      <div
                        className="spinner-border text-primary spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Carregando...</span>
                      </div>
                      <span className="text-muted">Redirecionando...</span>
                    </div>
                  )}

                  {/* Countdown */}
                  {!isRedirecting && countdown > 0 && (
                    <div className="alert alert-light border-0 bg-light bg-opacity-50">
                      <small className="text-muted">
                        <i className="bi bi-clock me-1"></i>
                        Redirecionamento automático em{" "}
                        <span className="countdown-number">
                          {countdown}
                        </span>{" "}
                        segundo{countdown !== 1 ? "s" : ""}
                      </small>
                    </div>
                  )}
                </div>
              </div>

              {/* Footer Info */}
              <div className="text-center mt-4">
                <small className="text-white text-opacity-75">
                  <i className="bi bi-shield-check me-1"></i>
                  Sessão encerrada com segurança
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bootstrap Icons */}
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-icons/1.10.0/font/bootstrap-icons.min.css"
      />
    </>
  );
};

export default LogoutScreen;
